"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var VisibleRenderer_1 = require("./VisibleRenderer");
var SwitchRenderer_1 = require("./SwitchRenderer");
var UPDATE_VIEWMODEL = 'update.viewmodel';
var PAGE_RENDERED = 'page.rendered';
window['React'] = React;
window['ReactDOM'] = ReactDOM;
var RenderEngineWrapper = (function () {
    function RenderEngineWrapper() {
        this.domNode = {};
        this.controls = {
            "Player": {
                "Repeater": {},
                "Switch": SwitchRenderer_1.Switch,
                "Visible": VisibleRenderer_1.Visible
            }
        };
    }
    RenderEngineWrapper.prototype.render = function (domNode) {
        var _this = this;
        this.domNode = domNode;
        if (csod.pages.hasOwnProperty(csod.context.package)
            && csod.pages[csod.context.package].hasOwnProperty(csod.context.page)
            && !csod.pageDefinition.hasOwnProperty('tree')) {
            var Page = csod.pages[csod.context.package][csod.context.page];
            ReactDOM.render(React.createElement(Page, { ref: function (c) { _this.renderEngine = c; } }), domNode);
        }
        else {
            throw new Error('Page definitions are missing. Check if your page is properly built and set up.');
        }
    };
    RenderEngineWrapper.prototype.forceRender = function (cb) {
        this.renderEngine
            ? this.renderEngine.forceRender(cb)
            : '';
    };
    RenderEngineWrapper.prototype.commit = function (cb) {
        this.forceRender(cb);
    };
    return RenderEngineWrapper;
}());
exports.RenderEngine = RenderEngineWrapper;
var Element = (function (_super) {
    __extends(Element, _super);
    function Element(props) {
        return _super.call(this, props) || this;
    }
    return Element;
}(React.Component));
Element.createElement = Element.createElement;
exports.Element = Element;
var Control = (function (_super) {
    __extends(Control, _super);
    function Control(props) {
        return _super.call(this, props) || this;
    }
    return Control;
}(Element));
exports.Control = Control;
var StatefulControl = (function (_super) {
    __extends(StatefulControl, _super);
    function StatefulControl(props) {
        return _super.call(this, props) || this;
    }
    return StatefulControl;
}(Element));
exports.StatefulControl = StatefulControl;



//////////////////
// WEBPACK FOOTER
// ./src/RenderEngine/index.tsx
// module id = 121
// module chunks = 0